import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { CountryCode } from '@ibe.models/country-code.model';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-new-contact-modal',
	templateUrl: './new-contact-modal.component.html',
	styleUrls: ['./new-contact-modal.component.scss']
})
export class NewContactModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

	private isAlive = true;

	contactForm = this.fb.group({
		name: ['', Validators.required],
		email:['',Validators.required],
		phone_prefix:['',Validators.required],
		phone_number:['', Validators.required]
	});

	countryCode$: Observable<Array<CountryCode>> = this.store.select(fromStore.getCountryCodes);
	countryCodes: Array<CountryCode>;
	dialCodes = [];

	constructor(
		protected modalService: ModalService,
		private store: Store<fromStore.State>,
		private fb: FormBuilder
	) {
		super(modalService);

		this.countryCode$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(values => {
			// Initialize countryCodes variable
			if (values) {
				this.countryCodes = values;

				for (const item of values) {
					this.dialCodes.push({
						label: item.name + ' ' + item.dial_code,
						value: item.code
					});
				}
			}
		});

	}

	ngOnDestroy(): void {
		this.isAlive=false;
	}

	ngOnInit() {
	}

	TAP_hasErrors(field){

	}
	TAP_formErrors(field){

	}

	TAP_formInvalid(field):boolean{
		return false;
	}

	TAP_handleCancel(){
		this.closeModal();
	}

	TAP_handleConfirm(){
		this.closeModal();
	}
}
